import React from 'react';
import { FlexColumnBox } from 'styles/global';
import { Card, useTheme } from '@mui/material';

export default function Auth({ children }) {
  const theme = useTheme();

  return (
    <FlexColumnBox
      sx={{
        p: 2,
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Card
        sx={{
          width: '100%',
          borderRadius: 3,
          boxShadow: 'unset',
          textAlign: 'center',
          p: {
            xs: 2,
            sm: 4
          },
          maxWidth: {
            xs: 320,
            sm: 550
          }
        }}
      >
        {children}
      </Card>
    </FlexColumnBox>
  );
}
